import styled from 'styled-components';
import Image from 'images/signin.jpg';

export const BackgroundImageWrapper = styled.div`
  min-height: 100vh;
  background-image: url(${Image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
`;
